<template>
  <div class="section center-vertical">
    <div class="section-horizontal mt-5 mb-5 nucleo08scroll1">
      <div class="horizontal-content">
        <div class="horizontal horizontal-1">
          <div class="titulo">Audiências de Custódia</div>
          <div class="text">
            Toda pessoa presa deve ser apresentada, no máximo, em 24h a uma
            autoridade judicial. São as chamadas audiências de custódia. O ato
            visa verificar se a prisão foi legal e se há incídios de que houve
            tortura ou maus tratos contra a pessoa custodiada.
          </div>
        </div>
        <div class="seta mx-5">
          <!-- <i class="bi bi-chevron-double-right"></i> -->
        </div>
        <div class="horizontal horizontal-2">
          <div class="titulo">Evidência de tortura</div>
          <div class="text">
            A evidência de tortura só se torna possível quando há condições
            mínimas para a escuta da pessoa custodiada. É o comparecimento
            presencial que permite que o magistrado detecte visualmente qualquer
            sinal ou indício de tortura e que adote as providências cabíveis
            para garantia da segurança da pessoa custodiada.
            <br /><br />Com audiências de custódia virtuais o combate a tortura
            se fragilizou. Como é possível esperar que uma pessoa denuncie a
            violência policial que acaba de sofrer de dentro de uma delegacia ou
            unidade prisional, confiando em interlocutores que se encontram do
            outro lado de uma tela de computador? <br /><br />Organizações da
            sociedade civil se manifestaram contrariamente à realização virtual
            das audiências de custódia denunciando a violação do direito das
            pessoas presas de serem levadas o mais rapidamente possível à
            presença de um juiz. Além de concluir que a medida descaracteriza o
            instituto, as entidades reforçaram a necessidade do amplo debate
            sobre o assunto.
          </div>
        </div>
        <div class="line"></div>
        <div class="horizontal horizontal-3">
          <div class="titulo">
            Sobre a legalidade da prisão e das ações policiais
          </div>
          <div class="text">
            Segundo relatório divulgado pela Pastoral Carcerária foram relatadas
            90 denúncias de tortura e violações de direitos humanos em todo o
            país, entre 15 de março e 31 de outubro de 2020. No meio de uma
            grave crise sanitária a proteção deveria ser redobrada, mas nos
            presídios brasileiros a lógica adotada foi a inversa. “A política
            negacionista destes últimos anos e a necropolítica atual, com sua
            desconstrução, destruição de todo e qualquer direito, constituem e
            concretizam o novo rosto da tortura”, analisa o padre Gianfranco
            Graziola.
          </div>
          <a
            class="link-fonte"
            href="https://ponte.org/denuncias-de-tortura-em-presidios-sobem-70-durante-pandemia/"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
          >
        </div>
        <div class="line"></div>
        <!-- <div class="horizontal horizontal-4">
          <div class="titulo">Manchetes</div>
          <div class="text">
            Denúncia de tortura em presidios sobre 70% na pandemia
          </div>
          <a
            class="link-fonte"
            href="https://ponte.org/denuncias-de-tortura-em-presidios-sobem-70-durante-pandemia/"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
          >
        </div>
        <div class="line"></div> -->
        <div class="horizontal horizontal-5">
          <div class="titulo">
            Audiências de custodia e denuncias de tortura
          </div>
          <!-- <div class="text">
            ISER lança vídeo crítico às audiências de custória por
            videoconferência
          </div> -->
          <div class="video-player">
            <iframe
              width="280"
              height="190"
              src="https://www.youtube.com/embed/rMc1nWpex7s"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <!-- <div class="line"></div>
        <div class="horizontal horizontal-5">
          <div class="titulo">Vídeos</div>
          <div class="video-player">
            <iframe
              width="280"
              height="190"
              src="https://www.youtube.com/embed/RRHEOF1nOVE"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div> -->
      </div>
    </div>
    <div class="arraste-section" @click="scrollRight()">
      Arraste para o lado <i class="bi bi-chevron-double-right seta"></i>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    scrollRight() {
      let content = document.querySelector(".nucleo08scroll1");
      content.scrollLeft += 300;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-red {
  margin-top: 60px;
  background-color: #d01c1f;
  color: white;
  font-family: Roboto Mono;
  padding: 2px 2px 0px 2px;
  font-size: 1.5rem;
  font-weight: 300;
}

.horizontal-content {
  color: #d01c1f;
  font-size: 1.1rem;
  font-family: Roboto Condensed;
  font-weight: 300;
  padding: 30px;
  display: flex;
  width: fit-content;
}

.seta {
  color: #626262;
}

.complemento {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.1rem;
  position: relative;
  top: -50px;
}

.line {
  width: 1px;
  background-color: #6262625b;
  height: 540px;
  margin: 0 55px;

  &.none {
    background-color: transparent;
    margin: 0 30px 0 15px;
  }
}

.horizontal {
  position: relative;
  overflow-y: auto;
  width: 100%;

  .data {
    font-size: 3rem;
    font-family: Roboto Mono;
    font-weight: 100;
  }

  .titulo {
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: 300;
    font-size: 1.8rem;
    line-height: 1.7rem;
    color: #d01c1f;
    margin-bottom: 30px;
    width: 260px;
  }
  .text {
    width: 270px;
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: 300;
    font-size: 1rem;
    line-height: 1.1rem;
    text-align: justify;
    color: #000000;
    margin-bottom: 30px;
    max-height: 400px;

    padding-right: 2px;

    b {
      color: #d01c1f;
    }

    &.big {
      font-size: 3rem;
      line-height: 3.1rem;
      font-family: Roboto Mono;
      color: #626262;
      font-weight: 100;
    }
  }
  img {
    width: 260px;
  }
  .numeracao {
    font-family: Roboto Mono;
    font-weight: 100;
    font-size: 3.3rem;
  }
}

*::-webkit-scrollbar {
  width: 0px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: #e4e4e4;
}

*::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}
</style>